import React from "react";
import { Instagram, Facebook, Youtube, Music2, AtSign } from "lucide-react";
import { footer } from "../mock";

const iconMap = {
  instagram: Instagram,
  facebook: Facebook,
  youtube: Youtube,
  tiktok: Music2,
  threads: AtSign,
};

export default function Footer() {
  return (
    <footer id="footer" className="bg-deep-brown pb-10 pt-24 text-[#F1E6D7]">
      <div className="mx-auto max-w-[1300px] px-6 md:px-10">
        <div className="grid grid-cols-1 gap-14 pb-16 md:grid-cols-2">
          <div>
            <h3 className="font-sans text-base font-light uppercase tracking-[0.3em] text-white sm:text-lg">
              {footer.brand}
            </h3>
            <p className="mt-3 font-sans text-[10px] uppercase tracking-[0.3em] text-bronze-light">
              {footer.tagline}
            </p>
            <div className="mt-8 space-y-2 text-[14px] font-light text-[#F1E6D7]/80">
              <a href={`mailto:${footer.email}`} className="block transition-colors hover:text-white">
                {footer.email}
              </a>
              <p>Phone: {footer.phone}</p>
            </div>
            <div className="mt-8 flex gap-3">
              {footer.socials.map((s) => {
                const Icon = iconMap[s.name];
                return (
                  <a
                    key={s.name}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`social-link-${s.name}`}
                    className="flex h-10 w-10 items-center justify-center border border-white/15 text-bronze-light transition-all duration-300 hover:border-bronze-light hover:bg-bronze-light hover:text-ink"
                    aria-label={s.name}
                  >
                    <Icon size={17} />
                  </a>
                );
              })}
            </div>
          </div>

          <div>
            <h4 className="font-sans text-[10px] uppercase tracking-[0.3em] text-bronze-light">Office</h4>
            <div className="mt-7 space-y-1.5 text-[14px] font-light text-[#F1E6D7]/80">
              {footer.office.lines.map((l) => (
                <p key={l}>{l}</p>
              ))}
            </div>
            <p className="mt-6 text-[14px] font-light text-[#F1E6D7]/80">{footer.office.note}</p>
          </div>
        </div>

        <div className="pb-14">
          <h4 className="font-sans text-[10px] uppercase tracking-[0.3em] text-bronze-light">Compliance</h4>
          <ul className="mt-7 max-w-md space-y-4 text-[14px] font-light text-[#F1E6D7]/70">
            {footer.compliance.map((c) => (
              <li key={c}>
                <a href="#" onClick={(e) => e.preventDefault()} className="transition-colors hover:text-white">
                  {c}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="border-t border-white/10 pt-8">
          <p className="max-w-3xl text-[11px] font-light leading-relaxed text-[#F1E6D7]/40">
            {footer.disclaimer}
          </p>
        </div>
      </div>
    </footer>
  );
}
